import { render, staticRenderFns } from "./AddContactsData.vue?vue&type=template&id=b1fcfaf2&scoped=true&"
import script from "./AddContactsData.vue?vue&type=script&lang=js&"
export * from "./AddContactsData.vue?vue&type=script&lang=js&"
import style0 from "./AddContactsData.vue?vue&type=style&index=0&id=b1fcfaf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fcfaf2",
  null
  
)

export default component.exports